export const inspectionsPermissions = {
    INSPECTIONS_ACCESS: {
        key: 'inspections.access',
        name: 'Access',
    },
}
